import React from 'react';
import { useTranslation } from 'react-i18next';
import { getProduct } from '../../product-catalog/productPresentation';
import ContentAction from '../shared/ContentAction';

export default function ProgramCard({ program }) {
  const { t } = useTranslation('app');
  const { action } = program;
  const name = program.productId ? getProduct(program.productId).name : program.name;
  return (
    <article className={`start-now-program-card${action.disabled ? ' is-disabled' : ''}`}>
      <div className="start-now-program-content">
        <div className="start-now-program-heading">
          <h3>{name}</h3>
          {action.disabled && <span className="start-now-program-status">{t('startNow.actions.comingSoon')}</span>}
        </div>
        <div className="start-now-program-category">{t(`startNow.programs.${program.id}.category`)}</div>
        <p className="start-now-program-description">{t(`startNow.programs.${program.id}.description`)}</p>
      </div>
      <ContentAction action={action} className="start-now-program-button">
        <span>{t(`startNow.actions.${action.disabled ? 'comingSoon' : action.label}`)}</span>
        {!action.disabled && <span aria-hidden="true">→</span>}
      </ContentAction>
    </article>
  );
}
